module.exports = __webpack_public_path__ + "img/GS_Profile-Joseph Moatlhudie.8e798522.png";